export default "__VITE_ASSET__5a0c3125__"